import ErrorContainer from '@/components/error/error-404'
import { SigninContainer } from '@/components/main/signin/signin'
import AboutUs from '@/pages/about/aboutUs'
import { DetailInfo } from '@/pages/golf/detailInfo/detailInfo'
import { DetailSearch } from '@/pages/golf/detailSearch/detailSearch'
import Main from '@/pages/main/main'
import CompleteMember from '@/pages/member/completeMember/completeMember'
import Management from '@/pages/member/management/management'
import Member from '@/pages/member/member'
import Mypage from '@/pages/member/mypage/mypage'
import NiceAuthResult from '@/pages/niceAuth/niceAuthResult'
import { NoticeDetail } from '@/pages/notice/_components/noticeDetail'
import Notice from '@/pages/notice/notice'
import Survey from '@/pages/survey/survey'
import YoutubeRank from '@/pages/youtube/youtubeRank'
import Promotion from '@/pages/promotion/promotion'
import { InsertPromotion } from '@/pages/promotion/_components/insertPromotion'
import { DetailPromotion } from '@/pages/promotion/_components/detailPromotion'
import InquiryBoard from '@/pages/board/inquiry/inquiryBoard'
import InquiryInsertBoard from '@/pages/board/inquiry/inquiryInsertBoard'
import InquiryDetailBoard from '@/pages/board/inquiry/inquiryDetailBoard'
import BlogBoard from '@/pages/blog/blogBoard'
import { InsertBlog } from '@/pages/blog/_components/insertBlog'
import DetailBlog from '@/pages/blog/_components/detailBlog'
import CommunityInsertBoard from '@/pages/board/community/_components/communityInsertBoard'
import CommunityDetailBoard from '@/pages/board/community/_components/communityDetailBoard'
import Feedback from '@/pages/feedback/feedback'
import { InsertFeedback } from '@/pages/feedback/_components/insertFeedback'
import { DetailFeedback } from '@/pages/feedback/_components/detailFeedback'
import NewMember from '@/pages/member/newMember/newMember'

export const routes = [
  {
    path: '/',
    element: <Main />,
  },
  {
    path: '/main',
    element: <Main />,
    label: '',
  },
  {
    path: '/about',
    element: <AboutUs />,
    label: '꿀프소개',
  },
  {
    path: '/golf/detailSearch',
    element: <DetailSearch />,
    label: '꿀프장검색',
    // requireAuth: true,  //2025.03.19 ljh 정보제공 목적으로 로그인 후 이용 옵션 제거
  },
  {
    path: '/youtube',
    element: <YoutubeRank />,
    label: '꿀플루언서',
  },
  {
    path: '/survey',
    element: <Survey />,
    label: '투표',
  },
  {
    path: '/blog',
    element: <BlogBoard />,
    label: '소통',
  },
  {
    path: '/inquiry',
    element: <InquiryBoard />,
    label: '문의',
  },
  {
    path: '/promotion',
    element: <Promotion />,
    label: '정보',
  },
  {
    path: '/feedback',
    element: <Feedback />,
    label: '목소리',
  },
  {
    path: '/notice',
    element: <Notice />,
    label: '공지사항',
  },
  // {
  //   path: '/sample',
  //   element: <Sample />,
  //   label: '',
  // },
  // {
  //   path: '/sample/result',
  //   element: <ResultPage />,
  //   label: '',
  // },
  {
    path: '/member',
    element: <Member />,
    label: '',
  },
  // {
  //   path: '/member/agree',
  //   element: <NewMember />,
  // },
  {
    path: '/member/newMember',
    element: <NewMember />,
  },
  {
    path: '/member/completeMember',
    element: <CompleteMember />,
  },
  {
    path: '/inquiry/write',
    element: <InquiryInsertBoard />,
  },
  {
    path: '/inquiry/detail',
    element: <InquiryDetailBoard />,
  },
  {
    path: '/community/write',
    element: <CommunityInsertBoard />,
  },
  {
    path: '/community/detail',
    element: <CommunityDetailBoard />,
  },
  {
    path: '/blog/write',
    element: <InsertBlog />,
  },
  {
    path: '/blog/detail',
    element: <DetailBlog />,
  },
  {
    path: '/promotion/write',
    element: <InsertPromotion />,
  },
  {
    path: '/promotion/detail',
    element: <DetailPromotion />,
  },
  {
    path: '/feedback/write',
    element: <InsertFeedback />,
  },
  {
    path: '/feedback/detail',
    element: <DetailFeedback />,
  },
  {
    path: '/login',
    element: <SigninContainer />,
    hideHeader: false,
    hideFooter: false,
    isFullWidth: true,
  },
  {
    path: '/mypage',
    element: <Mypage />,
    hideHeader: false,
    hideFooter: false,
  },
  {
    path: '/mypage/:type',
    element: <Mypage />,
    hideHeader: false,
    hideFooter: false,
  },
  {
    path: '/member/management/:type',
    element: <Management />,
    hideHeader: false,
    hideFooter: false,
  },
  {
    path: '/notice/detail',
    element: <NoticeDetail />,
  },
  {
    path: '/niceAuth/niceAuthResult',
    element: <NiceAuthResult />,
  },
  {
    path: '/golf/detailInfo',
    element: <DetailInfo />,
  },
  {
    path: '*',
    element: <ErrorContainer />,
    label: '',
  },
]
